import { SimpleGrid, Card, Text, Group, ThemeIcon, Title, Stack, Box, Progress, Badge, ActionIcon, Collapse } from '@mantine/core';
import { IconEye, IconDownload, IconExternalLink, IconHelpCircle, IconTrophy, IconChevronUp, IconChevronDown } from '@tabler/icons-react';
import { useState } from 'react';
import CommunityStatCard from './CommunityStatsCard';



export default function CommunityStatsDashboard({ globalStats, topResources }) {
    const [expandedIndex, setExpandedIndex] = useState(null);

    if (!globalStats) return null;
    const maxTotal = topResources[0]?.total || 1;

    return (
        <Stack mb="xl" gap="md">
            <Title order={4}>📊 Estadísticas generales</Title>

            <SimpleGrid cols={{ base: 2, sm: 4 }} spacing="md">
                <CommunityStatCard icon={<IconEye size={20} />} label="Vistas (modales)" value={globalStats.totalViews} color="blue" />
                <CommunityStatCard icon={<IconDownload size={20} />} label="Descargas" value={globalStats.totalDownloads} color="pink" />
                <CommunityStatCard icon={<IconExternalLink size={20} />} label="Clicks externos" value={globalStats.totalExternalClicks} color="teal" />
                <CommunityStatCard icon={<IconHelpCircle size={20} />} label="Clicks tutorial" value={globalStats.totalTutorialClicks} color="orange" />
            </SimpleGrid>

            {topResources.length > 0 && (
                <Card withBorder radius="md" p="md">
                    <Group mb="md">
                        <ThemeIcon color="yellow" variant="light" size="lg">
                            <IconTrophy size={18} />
                        </ThemeIcon>
                        <Title order={5}>Top 5 recursos más interactuados</Title>
                    </Group>

                    <Stack gap="sm">
                        {topResources.map((r, i) => (
                            <Box key={i}>
                                <Group justify="space-between" mb={4}>
                                    <Group gap="xs">
                                        <Text size="sm" fw={600} c="dimmed">#{i + 1}</Text>
                                        <Text size="sm" fw={500} lineClamp={1}>{r.title}</Text>
                                        <Badge size="xs" variant="outline">{r.category}</Badge>
                                    </Group>
                                    <Stack gap={0} align='end'>
                                        <Group gap={6}>
                                            <Text size="xs" c="dimmed">{r.total} interacciones</Text>
                                            <ActionIcon
                                                size="xs"
                                                variant="subtle"
                                                color="gray"
                                                onClick={() => setExpandedIndex(expandedIndex === i ? null : i)}
                                            >
                                                {expandedIndex === i ? <IconChevronUp size={12} /> : <IconChevronDown size={12} />}
                                            </ActionIcon>
                                        </Group>

                                        <Collapse in={expandedIndex === i}>
                                            <Group gap={6} mt={4} mb={6}>
                                                {r.views > 0 &&
                                                    <Badge size="xs" color="blue" variant="light" leftSection={<IconEye size={10} />}>
                                                        {r.views} {r.views === 1 ? 'vista' : 'vistas'}
                                                    </Badge>
                                                }
                                                {r.downloads > 0 &&
                                                    <Badge size="xs" color="pink" variant="light" leftSection={<IconDownload size={10} />}>
                                                        {r.downloads} {r.downloads === 1 ? 'descarga' : 'descargas'}
                                                    </Badge>
                                                }
                                                {r.external_clicks > 0 &&
                                                    <Badge size="xs" color="teal" variant="light" leftSection={<IconExternalLink size={10} />}>
                                                        {r.external_clicks} {r.external_clicks === 1 ? 'click externo' : 'clicks externos'}
                                                    </Badge>
                                                }
                                                {r.tutorial_clicks > 0 &&
                                                    <Badge size="xs" color="orange" variant="light" leftSection={<IconHelpCircle size={10} />}>
                                                        {r.tutorial_clicks} {r.tutorial_clicks === 1 ? 'tutorial' : 'tutoriales'}
                                                    </Badge>
                                                }
                                            </Group>
                                        </Collapse>
                                    </Stack>
                                </Group>



                                <Progress.Root size="sm">
                                    <Progress.Section value={(r.views / (r.total || 1)) * (r.total / maxTotal) * 100} color="blue" tooltip={`👁 ${r.views} vistas`} />
                                    <Progress.Section value={(r.downloads / (r.total || 1)) * (r.total / maxTotal) * 100} color="pink" tooltip={`⬇ ${r.downloads} descargas`} />
                                    <Progress.Section value={(r.external_clicks / (r.total || 1)) * (r.total / maxTotal) * 100} color="teal" tooltip={`🔗 ${r.external_clicks} clicks`} />
                                    <Progress.Section value={(r.tutorial_clicks / (r.total || 1)) * (r.total / maxTotal) * 100} color="orange" tooltip={`🎓 ${r.tutorial_clicks} tutoriales`} />
                                </Progress.Root>
                            </Box>
                        ))}
                    </Stack>

                    <Group gap="xs" mt="md">
                        {[['blue', 'Vistas'], ['pink', 'Descargas'], ['teal', 'Clicks externos'], ['orange', 'Tutoriales']].map(([color, label]) => (
                            <Group key={label} gap={4}>
                                <Box w={10} h={10} bg={color} style={{ borderRadius: 2 }} />
                                <Text size="xs" c="dimmed">{label}</Text>
                            </Group>
                        ))}
                    </Group>
                </Card>
            )}
        </Stack>
    );
}